<template>
  <div>
    <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
      <v-card>
        <v-toolbar dense class="">
          <v-toolbar-title>Update Email for @{{ influencerHandle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
          <!-- Popup content -->
          <v-card>
            <v-card-text>
                <v-text-field
                  prepend-icon="email"
                  type="email"
                  v-model="email"
                  :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                  @keydown.space.prevent
                  @paste="preventPasteSpaces"
                ></v-text-field>
            </v-card-text>
            <!-- Footer -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeModal"> Close </v-btn>
              <v-btn class="success" @click="updateEmail">Update</v-btn>
            </v-card-actions>
          </v-card>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';
import pairingAPIs from '../../Pairing/pairingAPIs';
import influencerAPIs from '../../Influencer/influencerAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'UpdateCreatorEmailModal',
  props: {
    value: Boolean,
    pairing: Object
  },
  components: {
    Loading
  },
  mixins: [validationMixin],
  data () {
    return {
      email: '',
      isLoading: false
    }
  },
  validations: {
    email: {
      required
    }
  },
  computed: {
    influencerHandle() {
      return this.pairing && this.pairing.influencer_details ? this.pairing.influencer_details.instagramHandle : '';
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push('Email is required');
      return errors;
    }
  },
  methods: {
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    },
    async updateEmail() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Invalid Email`,
          text: 'Make sure you filled the passcode correctly.'
        });
        return;
      }
      if (!this.pairing || !this.pairing.id) {
        this.$swal({
          text: 'Pairing data is unavailable. Please refresh and try again.',
          type: 'error'
        });
        return;
      }
      this.isLoading = true;
      // update pairings
      let contactDetails = {}
      let infDtls = null
      if (this.pairing.influencer_details) {
        infDtls = this.pairing.influencer_details
        if (this.pairing.influencer_details.contact_details) {
          contactDetails = this.pairing.influencer_details.contact_details
        }
        contactDetails.email = this.email
        infDtls.contact_details = contactDetails
      }
      let updatePairings = [{
        id: this.pairing.id,
        'influencer_details': infDtls
      }]
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      let resp = await pairingAPIs.updatePairings(formData)
      if (this.pairing && this.pairing.influencer_details && this.pairing.influencer_details.influencerID) {
        await influencerAPIs.editInfluencer({
          id: this.pairing.influencer_details.influencerID,
          email: this.email
        })
      }
      this.isLoading = false;
      if (!resp.status) {
        this.$swal({
          text: 'Error updating email.',
          type: 'error'
        });
        return
      }
      // Show success message
      this.$swal({
        text: 'Successfully updated email.',
        type: 'success'
      });
      this.$emit('updated')
      this.closeModal()
    },
    closeModal: function () {
      this.$v.$reset()
      this.$emit('input')
      this.email = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpdateCreatorEmailModal.vue?04eaae3e